import { createTheme } from "@mui/material/styles";
import textchestLogo from "./textchest/logo.png";

const PARTNERS = [
  { name: "textchest", domain: "voice.textchest.com" },
];

const getPartner = () => {
  for (const partner of PARTNERS) {
    if (partner.domain === window.location.host) {
      return partner.name;
    }
  }
  return undefined;
};

export const isTextchest = () => getPartner() === "textchest";
export const isDefaultPartner = () => getPartner() === undefined;

export const getPartnerDisplayName = () => {
  if (isTextchest()) return "TextChest";
  return "SMS Portal";
};

export const getLogoPath = () => {
  if (isTextchest()) return textchestLogo;
  return null;
};

export const getTheme = () => {
  if (isTextchest()) return textchestTheme;
  return defaultTheme;
};

const fontStack = [
  "Montserrat",
  "Roboto",
  '"Helvetica Neue"',
  "Arial",
  "sans-serif",
].join(",");

const defaultTheme = createTheme({
  palette: {
    primary: { main: "#1D4354" },
    secondary: { main: "#6FDA44" },
    default: { main: "#f2f2f2" },
  },
  typography: { fontFamily: fontStack },
  colors: {
    green: "#6FDA44",
    darkBlue: "#1D4354",
    grey: "#f2f2f2",
  },
});

const textchestTheme = createTheme({
  palette: {
    primary: { main: "#1877F2" },
    secondary: { main: "#1877F2" },
    default: { main: "#f2f2f2" },
  },
  typography: { fontFamily: fontStack },
  colors: {
    blue: "#1877F2",
    grey: "#f2f2f2",
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "#FFFFFF",
          color: "#1877F2",
          boxShadow: "0 1px 4px rgba(0,0,0,0.12)",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundColor: "#1877F2",
          "&:hover": { backgroundColor: "#1565C0" },
        },
      },
    },
  },
});
